import MomentTimezone from 'moment-timezone';
import { OLD_FORMAT_YMD_TIMEZONE } from '@/components/shared/date-format';

const ONLINE_LAST_SEEN_MINUTES = 10;
const ONLINE_LAST_SEEN_SECONDS = ONLINE_LAST_SEEN_MINUTES * 60;
const ONLINE_LAST_SEEN_MILLISECONDS = ONLINE_LAST_SEEN_SECONDS * 1000;
const DEVICE_TYPES = {
  RC: 'Recloser',
  GUARD: 'GUARD',
  guards1000: 'Guard 1000'
};

export default {
  methods: {
    isDeviceOnline(device) {
      const lastSeen = new Date(device.updatedAt);
      const currentTime = new Date();
      return currentTime - lastSeen <= ONLINE_LAST_SEEN_MILLISECONDS;
    },
    formatLastSeen(lastSeenDate) {
      return MomentTimezone(lastSeenDate).format(OLD_FORMAT_YMD_TIMEZONE);
    },
    deviceName(device) {
      const deviceType = device.deviceType || device.type;

      let deviceName = DEVICE_TYPES[deviceType] || device.deviceType;

      if (device.phase != null && device.lvFeederName != null) {
        deviceName = `${deviceName} ${device.port}.${device.phase}, LV feeder: [${device.lvFeederName}]`;
        if (device.lvWay != null) {
          deviceName = `${deviceName} - ${device.lvWay}`;
        }
      } else if (device.modbusAddress != null) {
        deviceName = `${deviceName}: modbus address: ${device.modbusAddress}`;
      }

      return deviceName;
    },
    deviceDetails(deviceObject) {
      if (deviceObject.length > 1) {
        return {
          name: DEVICE_TYPES[deviceObject[0].deviceType] || deviceObject[0].deviceType,
          lastSeen: this.formatLastSeen(deviceObject)
        };
      }

      return {
        name: DEVICE_TYPES[deviceObject.deviceType] || deviceObject.deviceType,
        port: deviceObject.port,
        phase: deviceObject.phase,
        lvFeeder: deviceObject.lvFeeder,
        lvWay: deviceObject.lvWay,
        modbusAddress: deviceObject.modbusAddress,
        lastSeen: this.formatLastSeen(deviceObject.updatedAt),
        switchState: deviceObject.data && deviceObject.data.switchState
      };
    }
  }
};
